import { render, staticRenderFns } from "./CreateMailingTemplatePage.vue?vue&type=template&id=79769b65&scoped=true&"
import script from "./CreateMailingTemplatePage.vue?vue&type=script&lang=js&"
export * from "./CreateMailingTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./CreateMailingTemplatePage.vue?vue&type=style&index=0&id=79769b65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79769b65",
  null
  
)

export default component.exports